import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import { Reveal } from "@/components/motion";
import { PageHero } from "@/pages/ServicesPage";
import { AREAS, IMAGES } from "@/data/content";

export default function LocationsPage() {
  return (
    <div data-testid="locations-page">
      <SEO
        title="Service Areas: Springbank, Bearspaw & Rocky View County | Estate Outdoors Calgary"
        description="Estate landscaping across Springbank, Bearspaw, Elbow Valley, Church Ranches, Watermark, Aspen Woods, Bragg Creek, Cochrane, Rocky View County and West Calgary."
      />
      <PageHero
        testid="locations-hero"
        eyebrow="Service Areas"
        title="Rooted in Calgary's Estate Country"
        subtitle="Deep local knowledge of acreage soils, foothills grades and chinook-season planting — across every community we serve."
        image={IMAGES.estateRoad}
      />

      <section className="py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal className="max-w-3xl">
            <p className="text-base md:text-lg leading-relaxed text-[#4A524C]">
              Estate Outdoors Calgary designs and builds luxury landscapes and outdoor living environments
              throughout Calgary and Rocky View County. Whether you're planning a Springbank acreage transformation,
              a Bearspaw estate landscape or new-build landscaping in Calgary's west end, our team
              brings proven local experience to your property.
            </p>
          </Reveal>

          <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {AREAS.map((a, i) => (
              <Reveal key={a.name} delay={0.05 * (i % 3)}>
                <div data-testid={`location-card-${a.name.toLowerCase().replace(/\s+/g, "-")}`} className="h-full border border-[#E0D8CC] bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_32px_rgba(28,32,29,0.08)] hover:border-[#C5A059]/50">
                  <span className="font-display italic text-sm text-[#8B5A2B]">{String(i + 1).padStart(2, "0")}</span>
                  <h2 className="mt-2 font-display text-2xl font-normal">{a.name}</h2>
                  <p className="mt-3 text-sm leading-relaxed text-[#4A524C]">{a.blurb}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal className="mt-16 text-center">
            <p className="text-base text-[#4A524C]">Don't see your community? We likely still serve your area.</p>
            <Link to="/quote" data-testid="locations-quote-btn" className="btn-primary mt-6">
              Ask About Your Property <ArrowRight size={16} />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
